import React, { Component } from 'react';
import { GET_MEDIA_NAME, GET_NETWORK_ICON, baseUrl } from '../../../../../utils';
import { ErrImg } from '../../../../CommonComponents/AssetsHelper';
import { Image } from 'react-bootstrap';

export default class Video extends Component {
  onErrorImageUpdate = event => {
    event.target.src = ErrImg
  }

  render() {
    const { postFile, height, width, socialNetworkId, alt } = this.props

    return <div className="position-relative rounded-1 bg-light overflow-hidden w-100" style={{ paddingBottom: '100%' }}>
      <Image className="position-absolute object-fit-cover w-100 h-100" loading="lazy" src={postFile} height={height} width={width} alt={alt != '' ? alt : GET_MEDIA_NAME(postFile)} onError={this.onErrorImageUpdate} />
      {socialNetworkId !== '' ?
        <div className="position-absolute p-2 end-0 bottom-0">
          <Image className="img-fluid" loading="lazy" src={baseUrl(`icons/social-icons/${GET_NETWORK_ICON(socialNetworkId)}.svg`)} height={20} width={20} alt={GET_NETWORK_ICON(socialNetworkId)} />
        </div>
        : null}
    </div>
  }
}